import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import type { ChatPresenterComponent } from '@core/tellent-assistant-contracts';
import type {
  ListItem,
  PresentCandidatesArgs,
  PresentEvaluationsArgs,
  PresentEventsArgs,
  PresentJobsArgs,
  PresentLinksArgs,
  PresentListArgs,
  PresentRequisitionsArgs,
  PresentSourcesArgs,
  PresentTalentPoolsArgs,
  PresentTasksArgs,
  PresentTeamMembersArgs,
} from '@core/tellent-assistant-types';

import { PresentListComponent } from './present-list.component';

const wrap = <K extends ListItem['kind']>(kind: K) =>
  function (data: Extract<ListItem, { kind: K }>['data']): Extract<ListItem, { kind: K }> {
    return <Extract<ListItem, { kind: K }>>{ kind, data };
  };

@Component({
  imports: [PresentListComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<rt-assistant-present-list [args]="mapped()" />`,
})
export class PresentCandidatesComponent implements ChatPresenterComponent<PresentCandidatesArgs> {
  protected readonly mapped = computed<PresentListArgs>(() => ({
    title: this.args().title,
    items: this.args().items.map(wrap('candidate')),
  }));
  public readonly args = input.required<PresentCandidatesArgs>();
}

@Component({
  imports: [PresentListComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<rt-assistant-present-list [args]="mapped()" />`,
})
export class PresentTeamMembersComponent implements ChatPresenterComponent<PresentTeamMembersArgs> {
  protected readonly mapped = computed<PresentListArgs>(() => ({
    title: this.args().title,
    items: this.args().items.map(wrap('team-member')),
  }));
  public readonly args = input.required<PresentTeamMembersArgs>();
}

@Component({
  imports: [PresentListComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<rt-assistant-present-list [args]="mapped()" />`,
})
export class PresentJobsComponent implements ChatPresenterComponent<PresentJobsArgs> {
  protected readonly mapped = computed<PresentListArgs>(() => ({
    title: this.args().title,
    items: this.args().items.map(wrap('job')),
  }));
  public readonly args = input.required<PresentJobsArgs>();
}

@Component({
  imports: [PresentListComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<rt-assistant-present-list [args]="mapped()" />`,
})
export class PresentTalentPoolsComponent implements ChatPresenterComponent<PresentTalentPoolsArgs> {
  protected readonly mapped = computed<PresentListArgs>(() => ({
    title: this.args().title,
    items: this.args().items.map(wrap('talent-pool')),
  }));
  public readonly args = input.required<PresentTalentPoolsArgs>();
}

@Component({
  imports: [PresentListComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<rt-assistant-present-list [args]="mapped()" />`,
})
export class PresentLinksComponent implements ChatPresenterComponent<PresentLinksArgs> {
  protected readonly mapped = computed<PresentListArgs>(() => ({
    title: this.args().title,
    items: this.args().items.map(wrap('link')),
  }));
  public readonly args = input.required<PresentLinksArgs>();
}

@Component({
  imports: [PresentListComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<rt-assistant-present-list [args]="mapped()" />`,
})
export class PresentSourcesComponent implements ChatPresenterComponent<PresentSourcesArgs> {
  protected readonly mapped = computed<PresentListArgs>(() => ({
    title: this.args().title,
    items: this.args().items.map(wrap('source')),
  }));
  public readonly args = input.required<PresentSourcesArgs>();
}

@Component({
  imports: [PresentListComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<rt-assistant-present-list [args]="mapped()" />`,
})
export class PresentEventsComponent implements ChatPresenterComponent<PresentEventsArgs> {
  protected readonly mapped = computed<PresentListArgs>(() => ({
    title: this.args().title,
    items: this.args().items.map(wrap('event')),
  }));
  public readonly args = input.required<PresentEventsArgs>();
}

@Component({
  imports: [PresentListComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<rt-assistant-present-list [args]="mapped()" />`,
})
export class PresentEvaluationsComponent implements ChatPresenterComponent<PresentEvaluationsArgs> {
  protected readonly mapped = computed<PresentListArgs>(() => ({
    title: this.args().title,
    items: this.args().items.map(wrap('evaluation')),
  }));
  public readonly args = input.required<PresentEvaluationsArgs>();
}

@Component({
  imports: [PresentListComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<rt-assistant-present-list [args]="mapped()" />`,
})
export class PresentTasksComponent implements ChatPresenterComponent<PresentTasksArgs> {
  protected readonly mapped = computed<PresentListArgs>(() => ({
    title: this.args().title,
    items: this.args().items.map(wrap('task')),
  }));
  public readonly args = input.required<PresentTasksArgs>();
}

@Component({
  imports: [PresentListComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<rt-assistant-present-list [args]="mapped()" />`,
})
export class PresentRequisitionsComponent implements ChatPresenterComponent<PresentRequisitionsArgs> {
  protected readonly mapped = computed<PresentListArgs>(() => ({
    title: this.args().title,
    items: this.args().items.map(wrap('requisition')),
  }));
  public readonly args = input.required<PresentRequisitionsArgs>();
}
